import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType } from '../ConfigTypes';
import { PUNISHMENT_TYPE } from '../../utils/constants';

/**
 * Delete description. Shown to deleted users
 */
const DeleteDescriptionPageItem = (): JSX.Element => {
  const { translate } = useTranslation();

  return <div data-testid='delete-description'>{translate('Description.Delete')}</div>;
};

const DeleteDescriptionPageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return punishmentData.punishmentTypeDescription === PUNISHMENT_TYPE.Delete;
  },
  renderComponent: DeleteDescriptionPageItem,
  configName: 'delete-description'
};

export default DeleteDescriptionPageItemConfig;
